<div class="button-wrapper" (click)="handleClick()" [ngClass]="{'gray-button-wrapper': style === 'gray'}">
  <div
    class="tertiary-button global-transition"
    [ngClass]="{
      'gray-button': style === 'gray',
      'smaller-button': size === 'smaller',
      'only-icon': !text || text === ''
    }">
    <nb-icon [icon]="icon" pack="icomoon" class="icon" *ngIf="icon"></nb-icon>
    <p class="text" *ngIf="text">{{ 'view_translations.' + text | translate }}</p>
  </div>
</div>
